export default __webpack_public_path__ + "static/maitai-still-435dbcdcb9d921a2f0ae33d64532b1b3.png";